import { styled } from '@mui/material/styles'
import Button from '@mui/material/Button'
import React from 'react'

interface StyledCancelButtonProps {
  children?: React.ReactNode
  onClick?: () => void
}

export const StyledCancelButton = styled(({ children, ...other }: StyledCancelButtonProps) => (
  <Button variant="contained" color="secondary" disableElevation {...other}>
    {children ?? 'Cancel'}
  </Button>
))({
  background: '#F5F5F5',
  color: '#000000',
  margin: 0,
  boxShadow: 'none',
  '&:hover': {
    background: '#d5d5d5',
    boxShadow: 'none',
  },
})
